const focusableElements = `
  a[href]:not([tabindex^="-"]),
  area[href]:not([tabindex^="-"]),
  button:not([disabled]):not([aria-hidden]):not([tabindex^="-"]),
  input:not([disabled]):not([aria-hidden]):not([type="hidden"]):not([tabindex^="-"]),
  select:not([disabled]):not([aria-hidden]):not([tabindex^="-"]),
  textarea:not([disabled]):not([aria-hidden]):not([tabindex^="-"]),
  embed:not([tabindex^="-"]),
  iframe:not([tabindex^="-"]),
  object:not([tabindex^="-"]),
  [contenteditable]:not([tabindex^="-"]),
  [tabindex]:not([tabindex^="-"])
`
const lastFocusableInBlocks = []
const firstFocusableInBlocks = []
const lastFocusableInBlockBeforeActive = []

const keydownListener = (e) => {
  const isTabPressed = e.key === 'Tab' || e.keyCode === 9

  if (!isTabPressed) {
    return
  }

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableInBlocks[firstFocusableInBlocks.length - 1]) {
      lastFocusableInBlocks[lastFocusableInBlocks.length - 1].focus()
      e.preventDefault()
    }
  } else if (document.activeElement === lastFocusableInBlocks[lastFocusableInBlocks.length - 1]) {
    firstFocusableInBlocks[firstFocusableInBlocks.length - 1].focus()
    e.preventDefault()
  }
}

export const activateFocusTrap = (block, tabindex) => {
  block.setAttribute('tabindex', typeof tabindex !== 'undefined' ? tabindex : 0)
  lastFocusableInBlockBeforeActive.push(document.activeElement)

  const firstFocusableInBlock = block.querySelectorAll(focusableElements)[0]
  firstFocusableInBlock && firstFocusableInBlocks.push(firstFocusableInBlock)

  const focusableItems = [...block.querySelectorAll(focusableElements)]
    .filter(el => !el.closest('[style*="display: none;"], [style*="display:none;"]'))

  const lastFocusableInBlock = focusableItems[focusableItems.length - 1]
  lastFocusableInBlock && lastFocusableInBlocks.push(lastFocusableInBlock)

  document.addEventListener('keydown', keydownListener)
}

export const deactivateFocusTrap = (block, tabindex) => {
  typeof tabindex !== 'undefined'
    ? block.setAttribute('tabindex', tabindex)
    : block.removeAttribute('tabindex')

  const lastActive = lastFocusableInBlockBeforeActive[lastFocusableInBlockBeforeActive.length - 1]

  if (lastActive) {
    lastActive.focus({ preventScroll: true })
    lastFocusableInBlockBeforeActive.pop()
  }

  firstFocusableInBlocks.pop()
  lastFocusableInBlocks.pop()

  !lastFocusableInBlocks.length && document.removeEventListener('keydown', keydownListener)
}
